document.addEventListener("DOMContentLoaded", function () {
  let current_country_code = $("body").attr("data-country-code");
  const firstLetterCap = current_country_code.toUpperCase();
  console.log('firstLetterCap: ' + firstLetterCap);

  if (sessionStorage.getItem("languageSelectedManually") === "true") {
    return;
  }

  let countryData = localStorage.getItem("cachedCountryData");
  var countryCode;

  if (countryData) {
    const parsedData = JSON.parse(countryData);
    countryCode = (parsedData.country_code === 'KR' || parsedData.country_code === 'KO') ? 'KO' : parsedData.country_code;
  } else {
    $.ajax({
      url: "https://ipapi.co/json/",
      method: "GET",
      dataType: "json",
      success: function (data) {
        console.log(data);
        localStorage.setItem("cachedCountryData", JSON.stringify(data));
        countryCode = data.country_code;

        handleRedirect(countryCode, firstLetterCap);
      },
      error: function (xhr, status, error) {
        console.error("IPinfo error:", error);
      }
    });
    return; // Exit early to wait for AJAX callback
  }

  handleRedirect(countryCode, firstLetterCap);
});

function handleRedirect(countryCode, firstLetterCap) {
  if (countryCode === "JP") {
    countryCode = "JA";
  }

  const supportedLanguages = ["JA", "FR", "DE", "ES", "NO", "KO", "HK"];
  let redirectURL = null;

  if (countryCode !== firstLetterCap) {
    switch (countryCode) {
      case "JA": redirectURL = "https://www.vr-wave.store/ja/"; break;
      case "FR": redirectURL = "https://www.vr-wave.store/fr/"; break;
      case "DE": redirectURL = "https://www.vr-wave.store/de/"; break;
      case "ES": redirectURL = "https://www.vr-wave.store/es/"; break;
      case "NO": redirectURL = "https://www.vr-wave.store/no/"; break;
      case "KO": redirectURL = "https://www.vr-wave.store/ko/"; break;
      case "HK": redirectURL = "https://www.vr-wave.store/zh-CN/"; break;
      default:
        if (localStorage.getItem("redirectedOnce") === "true") return;
        localStorage.setItem("redirectedOnce", "true");
        redirectURL = "https://www.vr-wave.store/";
        break;
    }
  }

  if (supportedLanguages.includes(countryCode)) {
    localStorage.removeItem("redirectedOnce");
  }

  if (redirectURL) {
    window.location.href = redirectURL;
  }
}

$(".lang_tab.ml_lang_texts_long").on("click", function () {
  const value = $(this).attr("value");
  console.log("Clicked value:", value);
  sessionStorage.setItem("languageSelectedManually", "true");
});



// document.addEventListener("DOMContentLoaded", async function () {
//   let current_country_code = $("body").attr("data-country-code");
//   const firstLetterCap = current_country_code.toUpperCase();
//   console.log('firstLetterCap'+firstLetterCap);
//   if (sessionStorage.getItem("languageSelectedManually") === "true") {
//     return;
//   }

//   // Check if country info is already in localStorage
//   let countryData = localStorage.getItem("cachedCountryData");
//   var countryCode;
//   console.log(countryData);
//   if (countryData) {
//     countryName = JSON.parse(countryData).country;
//     if(JSON.parse(countryData).country_code == 'KR' || JSON.parse(countryData).country_code == 'KO' ){
//       countryCode = 'KO'
//     }else{
//       countryCode = JSON.parse(countryData).country_code;
//     }
//   } else {
//     try {
//       // const response = await fetch("https://ipinfo.io/json?token=e933f21d32e574");
//       const response = await fetch("https://ipwho.is/");
//       const data = await response.json();
//       console.log(data);
//       localStorage.setItem("cachedCountryData", JSON.stringify(data)); // Cache API response
//       countryCode = data.country_code;
//     } catch (error) {
//       console.error("IPinfo error:", error);
//       return;
//     }
//   }

//   if (countryCode === "JP") {
//     countryCode = "JA";
//   }

//   let redirectURL = null;
//   const supportedLanguages = ["JA", "FR", "DE", "ES", "NO","KO","HK"];

//   if (countryCode !== firstLetterCap) {
//     switch (countryCode) {
//       case "JA":
//         redirectURL = "https://www.vr-wave.store/ja/";
//         break;
//       case "FR":
//         redirectURL = "https://www.vr-wave.store/fr/";
//         break;
//       case "DE":
//         redirectURL = "https://www.vr-wave.store/de/";
//         break;
//       case "ES":
//         redirectURL = "https://www.vr-wave.store/es/";
//         break;
//       case "NO":
//         redirectURL = "https://www.vr-wave.store/no/";
//         break;
//       case "KO":
//         redirectURL = "https://www.vr-wave.store/ko/";
//         break;
//      case "HK":
//         redirectURL = "https://www.vr-wave.store/zh-CN/";
//         break;   
//       default:
//         if (localStorage.getItem("redirectedOnce") === "true") {
//           return;
//         }
//         localStorage.setItem("redirectedOnce", "true");
//         redirectURL = "https://www.vr-wave.store/";
//         break;
//     }
//   }

//   if (supportedLanguages.includes(countryCode)) {
//     localStorage.removeItem("redirectedOnce");
//   }

//   if (redirectURL) {
//     window.location.href = redirectURL;
//   }
// });

// document.querySelectorAll(".lang_tab.ml_lang_texts_long").forEach(function (element) {
//   element.addEventListener("click", function () {
//     const value = this.getAttribute("value");
//     console.log("Clicked value:", value);
//     sessionStorage.setItem("languageSelectedManually", "true");
//   });
// });
